import client from '../../base-api';

const serviceURL = '/analytics/monthly-list';

const analyticsMonthlyListService = {
    getAssistedLivingCoachingList(filterData: any) {
        return client.get(`${serviceURL}/assisted-living-coaching`, {params: filterData});
    },
}

export default analyticsMonthlyListService;